import AbstractDeviceSetup from '../all/AbstractDeviceSetup';

class NetrangeDeviceSetup extends AbstractDeviceSetup {
  constructor() {
    super();
  }
}

export default NetrangeDeviceSetup;



// WEBPACK FOOTER //
// ./src/devices/netrange/DeviceSetup.js